module.exports = __webpack_public_path__ + "static/media/love_birds.57a3b42f.svg";